var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.666 26.3333L22.9993 23M22.9993 23L26.3327 26.3333M22.9993 23V30.5M29.666 26.9524C30.6839 26.1117 31.3327 24.8399 31.3327 23.4167C31.3327 20.8854 29.2807 18.8333 26.7493 18.8333C26.5673 18.8333 26.3969 18.7383 26.3044 18.5814C25.2177 16.7374 23.2114 15.5 20.916 15.5C17.4642 15.5 14.666 18.2982 14.666 21.75C14.666 23.4718 15.3622 25.0309 16.4885 26.1613",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.cc2c902444f321ffa6bc463cefb649ac.svg";
export { ForwardRef as ReactComponent };